import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { removeFloorPlanSelector } from 'selectors'
import { removeFloorPlanAction } from 'actions/floorPlanActions'
import { DESTROY_FLOOR_PLAN } from 'actions/floorPlanActionTypes'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import { updateUiAction } from 'actions/uiActions'
import findById from 'helpers/findById'

/** Add a floorPlan and then switch to it */
export function* destroyFloorPlan(action) {
  try {
    const { id } = action
    const { floorPlans, floorPlanScaleID } = yield select(removeFloorPlanSelector)
    const camera = yield call(findById, { state: floorPlans, id })

    // make sure to stop scaling if currently doing so
    if (id === floorPlanScaleID) {
      yield put(updateUiAction({ scaling: false, floorPlanScaleID: null }))
    }
    yield put(removeFloorPlanAction(id))
    yield call(camera.remove)
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for create floorPlan action, then call function */
export function* watchDestroyFloorPlan() {
  yield* takeEvery(DESTROY_FLOOR_PLAN, destroyFloorPlan)
}



// WEBPACK FOOTER //
// ./src/sagas/destroyFloorPlanSaga.js